import { z } from 'zod'
import { PaymentInterval } from './PaymentInterval'

// The terms state a switch meets, for the contract's owner: while
// needs_acceptance is set the switch takes the terms acceptance, for every
// contract of the account with can_accept, for this contract without it.
// governing_version is the version the contract runs on, null before any.
export const SwitchTerms = z.object({
  governing_version: z.string().nullable(),
  needs_acceptance: z.boolean(),
  can_accept: z.boolean()
})

export type SwitchTerms = z.infer<typeof SwitchTerms>

// What a tier switch or upgrade charges or refunds now, on the account's
// pricing basis. amount_cents is the quote a term-keeping switch is then
// made at; a monthly switch is made at charge_cents and refund_cents.
export const TermSwitchPreview = z.object({
  keeps_term: z.boolean(),
  // Empty for a switch that does not keep the term.
  billing_freq: PaymentInterval.optional().catch(undefined),
  // Exclusive end of the paid period, 00:00 German time after its last day.
  period_end: z.string().optional(),
  // charge and refund keep the term; upgrade, downgrade and switch (to or
  // from pay-as-you-go) are monthly.
  direction: z.enum(['charge', 'refund', 'none', 'upgrade', 'downgrade', 'switch']),
  amount_cents: z.number().int(),
  sepa_hold: z.boolean(),
  // What the target bills per period after the switch, times the quantity;
  // the base fee alone for pay-as-you-go.
  next_period_cents: z.number().int().optional(),
  charge_cents: z.number().int().optional(),
  refund_cents: z.number().int().optional(),
  // Exclusive end of the old plan's paid period refund_cents runs to.
  old_paid_end: z.string().optional(),
  // When the target's full monthly price starts: the next first of the month.
  next_period_start: z.string().optional(),
  // Whether the switch moves to a tier that costs more, which takes the
  // withdrawal consent even where nothing is charged.
  upgrade: z.boolean(),
  terms: SwitchTerms
})

export type TermSwitchPreview = z.infer<typeof TermSwitchPreview>
